import gql from "graphql-tag";

export const azzurroUserIdentityQuery = gql`
query {
  getAzzurroUserIdentities {
    ... on Operator {
      timestamp
      email
      active
      companyName
      tags
      __typename
    }
    ... on ServicePartnerCertification {
      active
      codSoggetto
      codiceAzienda
      codInstallatore
      companyName
      dataFine
      email
      emailCert
      tipoSkill
      tags
      __typename
    }
    ... on BaseCertificationInstaller {
      active
      codiceAzienda
      tipoSkill
      emailCert
      codInstallatore
      email
      dataFine
      companyName
      tags
      __typename
    }
    ... on AdvanceCertificationInstaller {
      active
      codiceAzienda
      tipoSkill
      emailCert
      email
      dataFine
      codInstallatore
      companyName
      tags
      __typename
    }
  }
}
`;
